import {ScribbleData} from '@docma-mm-core/scribble/scribble';
import {Size, TextAnnotation} from '@mydocma/component-library/src/lib/annotation';
import {toRGB} from './converter';


export class ArrowLegacyConverter {

  /* COMPONENT MODEL TO SCRIBBLE */
  static convertToData(anno: TextAnnotation, containerSize: Size): ScribbleData {
    // Not required for now
    return null;
  }

  /* SCRIBBLE TO COMPONENT MODEL */
  static convertToModel(scribble: ScribbleData, container: Size): TextAnnotation {
    const width = (scribble.RelativeScaleX || 0) * container.width;
    const left = container.width * scribble.RelativeBasePointToParentPositionX - (scribble.RelativeAnchorToCanvasPositionX || 0) * width;
    const height = (scribble.RelativeScaleY || 0) * container.height;
    const top = container.height * scribble.RelativeBasePointToParentPositionY  - (scribble.RelativeAnchorToCanvasPositionY || 0) * height;
    return {
      text: scribble?.Text,
      type: scribble.PinShape,
      id: scribble.UniqueId,
      style: {
        fillColor: toRGB(scribble.FillColorValue),
        text: {
          size: scribble.TextBoxFontSize,
          color: toRGB(scribble.TextBoxFontColorValue)
        },
        stroke: {
          color: toRGB(scribble.BorderColorValue),
          width: scribble.BorderWidth,
          opacity: 1
        }
      },
      width,
      height,
      top,
      left
    };


  }

}
